<template>
    <!-- <v-row no-gutters> -->
    <v-row>
        <v-col md="6" sm="12">
            <v-card variant="outlined" title="vizModel" subtitle="" id="vizTable"  style="height:90vh;">
                <v-data-table 
                    :headers="nodeListHeaders" 
                    :items="nodeList"
                    :items-per-page="10"
                    :fixed-header="true"
                    :height="tableHeight"
                    class="viz-table"
                >
                </v-data-table>
            </v-card>
        </v-col>
        <v-col md="6" sm="12">
            <v-row style="height:90vh;">
                <v-col cols="12">
                  <v-card variant="outlined" title="" subtitle="" id="vizChart" style="height:48vh;">
                        <v-card-title >
                          <v-btn small style="position: absolute; top: 10px; right: 10px;"
                                 @click="downloadChart('main2', 'volcano_chart.svg')">
                            Download SVG
                          </v-btn>
                        </v-card-title>
                      <div id="main2" style="height: 90%; margin-top: 10px"></div>
                    </v-card>
                  <div style="height: 4vh"></div>
                  <v-card variant="outlined" title="Chart Configurations" subtitle="" style="height:38vh;">
                    <ConfigsModifiedView @volcano-update="handleVolcanoUpdate"/>
                  </v-card>
                </v-col>
            </v-row>
        </v-col>
    </v-row>

    <v-row>
        <v-col md="6" sm="12">
        <v-card variant="outlined" title="" subtitle="" style="height:100vh;">
          <v-tabs v-model="currentTab">
                <v-tab value="Node" style="height: 5.5vh">Node Details</v-tab>
                <v-tab value="Edge" style="height: 5.5vh">Edge Details</v-tab>
          </v-tabs>
          <v-tab-item v-if="currentTab === 'Node'" value="Node">
                  <v-card-title >
                  <v-data-table :headers="nodeListHeaders" :items="nodeList" style="border-collapse: collapse"
                        items-per-page="12"></v-data-table>
                  </v-card-title>
            </v-tab-item>
            <v-tab-item v-if="currentTab === 'Edge'" value="Edge">
            
                  <v-card-title >
                  <v-data-table :headers="edgeListHeaders" :items="edgeList" style="border-collapse: collapse"
                        items-per-page="12"></v-data-table>
                  </v-card-title>
            </v-tab-item>
        </v-card>
        </v-col>
        <v-col md="6" sm="12">
          <v-card variant="outlined" title="Network" subtitle="" style="height:48vh; position: relative;">
            <div id="mainChart" style="height: 100%;"></div>
            <div style="position: absolute; top: 10px; right: 10px; display: flex; gap: 10px; align-items: center;">
              <v-btn-toggle v-model="chartsType" color="primary" size='small'>
                <v-btn value="force">Force</v-btn>
                <v-btn value="circular">Circular</v-btn>
              </v-btn-toggle>
              <v-btn small @click="downloadChart('mainChart', 'network_chart.svg')">
                Download SVG
              </v-btn>
            </div>
          </v-card>
          <div style="height:4vh;"></div>
            <v-card variant="outlined" title="Configuration" subtitle="" style="height:48vh;">
                <ConfigsView @network-update="handleNetworkUpdate"/>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import axios from 'axios';
import ConfigsView from "./ConfigsView.vue";
import ConfigsModifiedView from "@/views/estat/statmo/ConfigsModifiedView.vue";
import { mapGetters, mapState } from 'vuex';
export default {
    name: 'VizModel',
    components: {
        ConfigsView,
        ConfigsModifiedView,
  },
  computed: {
    ...mapGetters(['deepestColor', 'lightestColor']),
    ...mapState(['nodeSize', 'nodeNameType', 'nodeType', 'lineWidth', 'nodeTransparency', 'lineTransparency', 'lineColor', 'nodeColor', 'labelSize', 'volcanoNodeNameType', 'networkLabelSize'])
  },
    data() {
        return {
            edgeListHeaders: [],
            edgeList: [],
            nodeListHeaders: [],
            nodeList: [],
            currentTab: 'Node',
            chartsType: "force",
            configAreaStyle: {
                height: ''
            },
            tableHeight: 500,
            tableDetailsHeight: 500,
            min: 0,
            max: 90,
            slider: 40,
        };
    },
    created() { },
    async mounted() {
        // tmD 异步死老子了
        await this.doAllTable()
        await this.initVolcanoChart()
        await this.initmyChart("circular")
        await this.initmyChart("force")
        await this.calculateConfigAreaHeight()
        this.calculateTableHeight()
        this.calculateTableDetailsHeight()
    },
  watch: {
    // 监听 chartsType 的变化，重新渲染相应的图表
    chartsType(newValue) {
      if (newValue === 'circular') {
        this.initmyChart('circular');
      } else if (newValue === 'force') {
        this.initmyChart('force');
      }
    },
    deepestColor(newColor) {
      this.updateVisualMap(newColor, this.lightestColor);
    },
    lightestColor(newColor) {
      this.updateVisualMap(this.deepestColor, newColor);
    },
    nodeNameType() {
      this.initVolcanoChart();
    },
    nodeType() {
      this.updateNodeSizes();
    },
    lineWidth(newWidth) {
      this.updateLineWidth(newWidth);
    },
    lineTransparency(newValue) {
      this.updateLineTransparency(newValue);
    },
    lineColor(newColor) {
      this.updateLineColor(newColor);
    },
    nodeColor(newColor) {
      this.updateNodeColor(newColor);
    },
    labelSize(newSize) {
      const volcanoChart = document.getElementById("main2");
      if (volcanoChart) {
        const myChart = this.$echarts.getInstanceByDom(volcanoChart);
        if (myChart) {
          myChart.setOption({
            series: [{
              label: {
                fontSize: newSize
              }
            }]
          });
        }
      }
    }
  },
    methods: {
      downloadChart(chartId, filename) {
            const chartElement = document.getElementById(chartId);
            if (chartElement) {
                const myChart = this.$echarts.getInstanceByDom(chartElement);
                if (myChart) {
                    const svgData = myChart.getDataURL({
                        type: 'svg',
                        backgroundColor: '#fff',
                    });
                    const link = document.createElement('a');
                    link.href = svgData;
                    link.download = filename;
                    link.click();
                }
            }
        },
        async doAllTable() {
            var respEdgeData = await this.doTable("Edge_Step1.by.lasso.xlsx")
            this.edgeListHeaders = respEdgeData["header"]
            this.edgeList = respEdgeData["node"]
            for (var j in this.edgeList) {
                this.edgeList[j].R = this.formatFloatNumber(this.edgeList[j].R)
                this.edgeList[j].P = this.formatFloatNumber(this.edgeList[j].P)
            }

            var respNodeData = await this.doTable("Node_Step1.by.lasso.xlsx")
            this.nodeListHeaders = respNodeData["header"]
            this.nodeList = respNodeData["node"]

            for (var i in this.nodeList) {
                this.nodeList[i]["name"] = this.nodeList[i]["id"]
                this.nodeList[i]["value"] = 10
                this.nodeList[i].Coef = this.formatFloatNumber(this.nodeList[i].Coef)
                this.nodeList[i].MinusLog10P = this.formatFloatNumber(this.nodeList[i].MinusLog10P)
                this.nodeList[i].ModelIndex = this.formatFloatNumber(this.nodeList[i].ModelIndex)
                this.nodeList[i].P = this.formatFloatNumber(this.nodeList[i].P)
            }
          console.log(this.nodeList)
        },
        async doTable(filename) {
            let data = JSON.stringify({
                "path": "demo/",
                "filename": filename
            })
            try {
                const response = await axios.post('/exposome/getstatic', data, {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });
                var rsp = this.$globalParseCsvData(response.data)
                return rsp
            } catch (error) {
                console.log(error)
            }
        },
        async calculateConfigAreaHeight() {
            let vizTableHeight = document.getElementById('vizTable').offsetHeight
            let vizChartHeight = document.getElementById('vizChart').offsetHeight
            this.configAreaStyle.height = vizTableHeight - vizChartHeight - 24 + 'px'
            this.configAreaStyle.margin = 0
            // console.dir(vizTableHeight)
        },
        calculateTableHeight() {
            // 使用90vh计算，减去一些空间给标题、边距和footer
            const viewportHeight = window.innerHeight
            this.tableHeight = (viewportHeight * 0.9) - 120 // 90vh - 120px
        },
        calculateTableDetailsHeight() {
            // 计算Node Details和Edge Details表格的高度
            // 100vh - 5.5vh(tabs) - 100px(footer、分页器和边距)
            const viewportHeight = window.innerHeight
            this.tableDetailsHeight = viewportHeight - (viewportHeight * 0.055) - 100
        },
        initVolcanoChart() {
    var myChart = this.$echarts.init(document.getElementById("main2"), null, { renderer: 'svg' });

    // 准备数据
    var data = this.nodeList.map(item => [
        item['Coef'],          // x: Coef
        item['MinusLog10P'],   // y: MinusLog10P
        item['Coef'],          // 映射到 visualMap
        item['group']          // 分组
    ]);

    var option = {
        color: ['#c23531'],
        xAxis: {
            type: 'value',
            name: 'Coef',
            nameLocation: 'end',
            nameGap: 16,
            nameTextStyle: {
              fontSize: 16,
              fontWeight: 'bold',
              color: '#212121'
            },
            splitLine: {
                show: false
            }
        },
        yAxis: {
            type: 'value',
            name: 'MinusLog10P',
            nameLocation: 'middle', // 标题居中显示
            nameRotate: 90,         // 标题旋转 90 度
            nameGap: 40,            // 调整标题与轴线的距离
            nameTextStyle: {
                fontSize: 16,
                fontWeight: 'bold',
                color: '#212121'        // 可自定义颜色
            },
            splitLine: {
                show: false
            }
        },
        tooltip: {
            trigger: 'item',
            formatter: (params) => {
                const node = this.nodeList.find(n => n.Coef === params.data[0] && n.MinusLog10P === params.data[1]);
                
                // 根据 nodeNameType 选择显示内容
                switch(this.volcanoNodeNameType) {
                    case '1': // EXID
                        return `
                            <b>Name:</b> ${node.id}<br>
                            <b>Coef:</b> ${params.data[0]}<br>
                            <b>Log10P:</b> ${params.data[1]}<br>
                            <b>Group:</b> ${params.data[3]}
                        `;
                    case '2': // Preferred name
                        return `
                            <b>Name:</b> ${node.label}<br>
                            <b>Coef:</b> ${params.data[0]}<br>
                            <b>Log10P:</b> ${params.data[1]}<br>
                            <b>Group:</b> ${params.data[3]}
                        `;
                    case '3': // No name
                        return '';
                }
            }
        },
        visualMap: [{
            type: 'continuous',
            orient: 'vertical',
            left: 'right',
            top: '0',
            dimension: 1, // 根据 y 值 (MinusLog10P) 筛选
            min: Math.min(...data.map(d => d[1])), // y 值最小
            max: Math.max(...data.map(d => d[1])), // y 值最大
            itemWidth: 30,
            itemHeight: 200,
            calculable: true,
            precision: 0.1,
            textGap: 30,
            inRange: {
                color: [this.deepestColor, this.lightestColor]
            },
            outOfRange: {
                color: 'transparent'
            },
            backgroundColor: 'transparent',
            borderColor: 'transparent'
        }],
        legend: {
            top: '0',
            right: '5'
        },
        series: [{
            data: data,
            type: 'scatter',
            symbolSize: this.nodeSize,
            itemStyle: {
                opacity: this.nodeTransparency / 100
            },
            label: {
                show: true,
                position: 'right',
                formatter: (params) => {
                    const node = this.nodeList.find(n => n.Coef === params.data[0] && n.MinusLog10P === params.data[1]);
                    switch(this.volcanoNodeNameType) {
                        case '1': // EXID
                            return node.id;
                        case '2': // Preferred name
                            return node.label;
                        case '3': // No name
                            return '';
                    }
                },
                fontSize: this.labelSize // 动态调整字体大小
            },
            animationDuration: 1000,
            animationEasing: 'cubicOut'
        }]
    };

    option && myChart.setOption(option);
},
        initmyChart(chartsType) {
    const elementId = 'mainChart';
    const myChart = this.$echarts.init(document.getElementById(elementId), null, { renderer: 'svg' });

    const categoriesMap = {};
    const categories = [];
    const legendData = [];

    // 构建分类信息
    for (const node of this.nodeList) {
        categoriesMap[node.group] = 1;
    }

    let categoryIndex = 0;
    for (const group in categoriesMap) {
        categories.push(group);
        categoriesMap[group] = categoryIndex++;
        legendData.push({ name: group });
    }

    // 为节点添加分类索引
    for (const node of this.nodeList) {
        node.category = categoriesMap[node.group];
    }

    const option = {
        tooltip: {
            formatter: (params) => {
                if (params.dataType === 'node') {
                    switch(this.nodeNameType) {
                        case '1': // EXID
                            return `<b>Name:</b> ${params.data.id}`;
                        case '2': // Preferred name
                            return `<b>Name:</b> ${params.data.label}`;
                        case '3': // No name
                            return '';
                    }
                } else if (params.dataType === 'edge') {
                    return `<b>R:</b> ${params.data.R}<br><b>P:</b> ${params.data.P}`;
                }
            }
        },
        legend: [{
            data: legendData,
            orient: 'vertical',
            left: 'left',
            top: 'top',
            textStyle: {
                fontSize: 12,
                color: '#000',
            },
        }],
        animation: false, // 禁用动画
        series: [{
            type: 'graph',
            layout: chartsType,
            data: this.nodeList,
            links: this.edgeList,
            roam: true,
            draggable: true,
            categories: categories.map(name => ({ name })),
            label: {
                show: true,
                position: 'right',
                formatter: (params) => {
                    switch(this.nodeNameType) {
                        case '1': // EXID
                            return params.data.id;
                        case '2': // Preferred name
                            return params.data.label;
                        case '3': // No name
                            return '';
                    }
                },
                fontSize: this.networkLabelSize
            },
            symbolSize: this.nodeSize,
            lineStyle: {
                width: this.lineWidth,
                color: this.lineColor,
                opacity: this.lineTransparency / 100
            },
            itemStyle: {
                opacity: this.nodeTransparency / 100
            },
            force: {
                repulsion: 100,
                layoutAnimation: false,
            },
        }],
    };

    myChart.setOption(option);

    // 监听拖拽事件，固定节点位置
    myChart.on('dragend', (params) => {
        if (params.componentType === 'series' && params.seriesType === 'graph') {
            const nodeIndex = params.dataIndex;
            const position = myChart.convertFromPixel({ seriesIndex: 0 }, [params.event.offsetX, params.event.offsetY]);

            // 更新节点的固定位置
            this.nodeList[nodeIndex].x = position[0];
            this.nodeList[nodeIndex].y = position[1];
            this.nodeList[nodeIndex].fixed = true; // 固定节点
            myChart.setOption({
                series: [{
                    data: this.nodeList,
                }],
            });
        }
    });
},
        updateVisualMap(deepestColor, lightestColor) {
            const chartElement = document.getElementById("main2");
            if (!chartElement) return;

            const myChart = this.$echarts.getInstanceByDom(chartElement);
            if (myChart) {
                myChart.setOption({
                    visualMap: [{
                        inRange: {
                            color: [deepestColor, lightestColor],
                        },
                    }],
                });
            }
        },
        updateNodeSize(newSize) {
            // 更新火山图
            const volcanoChart = document.getElementById("main2");
            if (volcanoChart) {
                const myChart = this.$echarts.getInstanceByDom(volcanoChart);
                if (myChart) {
                    myChart.setOption({
                        series: [{
                            symbolSize: newSize
                        }]
                    });
                }
            }

            // 更新网络图
            const networkChart = document.getElementById("mainChart");
            if (networkChart) {
                const myChart = this.$echarts.getInstanceByDom(networkChart);
                if (myChart) {
                    myChart.setOption({
                        series: [{
                            symbolSize: newSize
                        }]
                    });
                }
            }

            // 更新节点大小
            this.updateNodeSizes();
        },
        formatFloatNumber(num) {
            let floatNum = parseFloat(num)
            return floatNum.toFixed(3)
        },
        updateNodeSizes() {
          if (this.nodeType === '2') {
            // 计算每个节点的边数量
            const edgeCounts = {};
            this.edgeList.forEach(edge => {
              edgeCounts[edge.source] = (edgeCounts[edge.source] || 0) + 1;
              edgeCounts[edge.target] = (edgeCounts[edge.target] || 0) + 1;
            });

            // 找出最大边数
            const maxEdges = Math.max(...Object.values(edgeCounts));
            
            // 更新节点大小
            this.nodeList.forEach(node => {
              const edgeCount = edgeCounts[node.id] || 0;
              // 将边数映射到节点大小范围（基础大小到基础大小+10）
              node.value = this.nodeSize + (edgeCount / maxEdges) * 10;
            });
          } else {
            // 所有节点大小一致
            this.nodeList.forEach(node => {
              node.value = this.nodeSize;
            });
          }

          // 只更新网络图
          this.initmyChart(this.chartsType);
        },
        updateLineWidth(newWidth) {
            // 更新网络图
            const networkChart = document.getElementById("mainChart");
            if (networkChart) {
                const myChart = this.$echarts.getInstanceByDom(networkChart);
                if (myChart) {
                    myChart.setOption({
                        series: [{
                            lineStyle: {
                                width: newWidth
                            }
                        }]
                    });
                }
            }
        },
        updateLineTransparency(newValue) {
            // 更新网络图
            const networkChart = document.getElementById("mainChart");
            if (networkChart) {
                const myChart = this.$echarts.getInstanceByDom(networkChart);
                if (myChart) {
                    myChart.setOption({
                        series: [{
                            lineStyle: {
                                opacity: newValue / 100
                            }
                        }]
                    });
                }
            }
        },
        updateLineColor(newColor) {
            // 更新网络图
            const networkChart = document.getElementById("mainChart");
            if (networkChart) {
                const myChart = this.$echarts.getInstanceByDom(networkChart);
                if (myChart) {
                    myChart.setOption({
                        series: [{
                            lineStyle: {
                                color: newColor
                            }
                        }]
                    });
                }
            }
        },
        updateNodeColor(newColor) {
            // 更新网络图
            const networkChart = document.getElementById("mainChart");
            if (networkChart) {
                const myChart = this.$echarts.getInstanceByDom(networkChart);
                if (myChart) {
                    myChart.setOption({
                        series: [{
                            itemStyle: {
                                color: newColor
                            }
                        }]
                    });
                }
            }
        },
        updateNodeTransparency(newValue) {
            // 只更新网络图
            const networkChart = document.getElementById("mainChart");
            if (networkChart) {
                const myChart = this.$echarts.getInstanceByDom(networkChart);
                if (myChart) {
                    myChart.setOption({
                        series: [{
                            itemStyle: {
                                opacity: newValue / 100
                            }
                        }]
                    });
                }
            }
        },
        handleVolcanoUpdate(update) {
            const volcanoChart = document.getElementById("main2");
            if (!volcanoChart) return;
            
            const myChart = this.$echarts.getInstanceByDom(volcanoChart);
            if (!myChart) return;

            switch (update.type) {
                case 'color':
                    if (update.deepestColor) {
                        this.updateVisualMap(update.deepestColor, this.lightestColor);
                    }
                    if (update.lightestColor) {
                        this.updateVisualMap(this.deepestColor, update.lightestColor);
                    }
                    break;
                case 'transparency':
                    myChart.setOption({
                        series: [{
                            itemStyle: {
                                opacity: update.transparency / 100
                            }
                        }]
                    });
                    break;
                case 'size':
                    myChart.setOption({
                        series: [{
                            symbolSize: update.size
                        }]
                    });
                    break;
                case 'nameType':
                    this.initVolcanoChart();
                    break;
            }
        },
        handleNetworkUpdate(update) {
            const networkChart = document.getElementById("mainChart");
            if (!networkChart) return;
            
            const myChart = this.$echarts.getInstanceByDom(networkChart);
            if (!myChart) return;

            switch (update.type) {
                case 'nameType':
                    this.initmyChart(this.chartsType);
                    break;
                case 'nodeType':
                    this.updateNodeSizes();
                    break;
                case 'size':
                    myChart.setOption({
                        series: [{
                            symbolSize: update.size
                        }]
                    });
                    this.updateNodeSizes();
                    break;
                case 'lineWidth':
                    myChart.setOption({
                        series: [{
                            lineStyle: {
                                width: update.lineWidth
                            }
                        }]
                    });
                    break;
                case 'labelSize':
                    myChart.setOption({
                        series: [{
                            label: {
                                fontSize: update.size
                            }
                        }]
                    });
                    break;
                case 'nodeTransparency':
                    this.updateNodeTransparency(update.nodeTransparency);
                    break;
                case 'lineTransparency':
                    myChart.setOption({
                        series: [{
                            lineStyle: {
                                opacity: update.lineTransparency / 100
                            }
                        }]
                    });
                    break;
                case 'lineColor':
                    myChart.setOption({
                        series: [{
                            lineStyle: {
                                color: update.lineColor
                            }
                        }]
                    });
                    break;
                case 'nodeColor':
                    // 更新节点颜色
                    this.nodeList.forEach(node => {
                        node.itemStyle = {
                            color: update.nodeColors[node.group] || '#5470c6',
                            opacity: this.nodeTransparency / 100
                        };
                    });
                    myChart.setOption({
                        series: [{
                            data: this.nodeList
                        }]
                    });
                    break;
            }
        },
    },
}



</script>

<style>
/* 确保表格容器有固定高度和滚动 - 只针对vizTable中的表格 */
#vizTable ::v-deep(.v-data-table) {
  overflow: hidden;
  position: relative;
  max-height: 90vh; /* 限制表格最大高度为90vh */
}

#vizTable ::v-deep(.v-data-table__wrapper) {
  overflow-y: auto;
  max-height: calc(90vh - 120px); /* 考虑90vh容器高度，为footer和标题留出空间 */
}

/* 确保表头固定 - 只针对vizTable中的表格 */
#vizTable ::v-deep(.v-data-table__thead) {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: white;
}

/* 确保表格体可以滚动 - 只针对vizTable中的表格 */
#vizTable ::v-deep(.v-data-table__tbody) {
  overflow-y: auto;
  max-height: calc(90vh - 180px); /* 考虑90vh容器高度，为表头、footer和标题留出空间 */
}

/* 确保表格内容不会溢出 - 只针对vizTable中的表格 */
#vizTable ::v-deep(.v-data-table__tbody tr) {
  height: auto;
  min-height: 48px;
}

/* 自定义分页器样式 - 只针对vizTable中的表格 */
#vizTable ::v-deep(.v-data-table-footer) {
  position: sticky;
  bottom: 0;
  background-color: white;
  z-index: 1000; /* 提高z-index确保在最上层 */
  border-top: 1px solid #e0e0e0;
  box-shadow: 0 -2px 4px rgba(0,0,0,0.1);
  min-height: 60px;
  padding: 0;
  margin-top: auto; /* 确保footer在容器底部 */
}

/* Node Details和Edge Details表格的滚动样式 - 简单版本 */
.v-card[style*="height:100vh"] ::v-deep(.v-data-table) {
  overflow: hidden;
}

.v-card[style*="height:100vh"] ::v-deep(.v-data-table__wrapper) {
  overflow-y: auto;
  max-height: calc(90% - 60px); /* 为footer留出空间 */
}

.v-card[style*="height:100vh"] ::v-deep(.v-data-table__thead) {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: white;
}

.v-card[style*="height:100vh"] ::v-deep(.v-data-table__tbody) {
  overflow-y: auto;
}

.v-card[style*="height:100vh"] ::v-deep(.v-data-table__tbody tr) {
  height: auto;
  min-height: 48px;
}

/* 确保footer固定在底部 */
.v-card[style*="height:100vh"] ::v-deep(.v-data-table-footer) {
  position: sticky;
  bottom: 0;
  background-color: white;
  z-index: 100;
  border-top: 1px solid #e0e0e0;
  box-shadow: 0 -2px 4px rgba(0,0,0,0.1);
  min-height: 60px;
  padding: 8px 0;
}

</style>